import { sendCode } from './sendCode';
import { checkPhone } from './checkPhone';
/* fixme временный action на период эксперимента с переходом на новый флоу пользовательского соглашения */

export function applyPhone() {
  return function (dispatch, getState) {
    var _getState = getState(),
        isNextAgreementFlow = _getState.isNextAgreementFlow;

    if (isNextAgreementFlow) {
      dispatch(checkPhone());
    } else {
      dispatch(sendCode());
    }
  };
}